var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7313 2.76869C21.239 2.2765 20.5714 2 19.8753 2C19.1791 2 18.5115 2.2765 18.0193 2.76869L16.8623 3.92569L20.5743 7.63769L21.7313 6.48069C22.2234 5.98842 22.4999 5.32081 22.4999 4.62469C22.4999 3.92857 22.2234 3.26096 21.7313 2.76869ZM19.5133 8.69869L15.8013 4.98669L3.65125 17.1367C3.03411 17.7535 2.58043 18.5145 2.33125 19.3507L1.53125 22.0357C1.49263 22.1653 1.48975 22.3029 1.52292 22.4339C1.55608 22.565 1.62407 22.6847 1.71967 22.7803C1.81527 22.8759 1.93494 22.9439 2.06601 22.977C2.19709 23.0102 2.33469 23.0073 2.46425 22.9687L5.14925 22.1687C5.98548 21.9195 6.74642 21.4658 7.36325 20.8487L19.5133 8.69969V8.69869Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.141ff473cf2d891a04b56ca68b791baf.svg";
export { ForwardRef as ReactComponent };